<template lang="pug">
.v-bill-promo.bill-promo(v-if="data" :style="{backgroundColor: data.backgroundColor}")
	.container
		.bill-promo__wrapper
			.bill-promo__title(v-if="data.title") {{data.title}}
			.bill-promo__text(v-if="data.text") {{data.text}}
			.bill-promo__items(v-if="data.items && data.items.length")
				.bill-promo__item(v-for="(item, idx) in data.items" :key="idx")
					.bill-promo__item-title(v-if="item.title" v-html="item.title")
					.bill-promo__item-text(v-if="item.text" v-html="item.text")
					.bill-promo__terms(v-if="item.items && item.items.length")
						v-terms-box(v-for="term in item.items" :data-source="term")
					.bill-promo__image-wrap(v-if="item.image")
						img.bill-promo__image(:src="item.image.src" :alt="item.image.alt")
					.bill-promo__item-description(v-if="item.description") {{item.description}}
</template>

<script>

import sourceMixin from "components/mixins/v-mixin-source.vue";

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
};
</script>